import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./editProjectModal.css";
import Modal from "react-modal";

import {
  createProject,
  editProject,
  saveEditProject,
} from "../../redux/actions/Projects";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    borderRadius: "8px",
  },
};

const modelNames = [
  "Urgent Capability Acquisition Pathway",
  "Middle Tier Acquisition Pathway",
  "Major Capability Acquisition Pathway",
  "Software Acquisition Pathway",
  "Defense Business Systems Pathway",
  "Acquisition of Services Pathway",
];

const NewProjectModal: React.FC<{
  project: any;
  editProject: (project: any) => void;
  saveEditProject: (formData: any) => void;
  style: any;
}> = ({ project, editProject, saveEditProject, style }) => {
  const [formData, setFormData] = useState({
    name: project?.name,
    description: project?.description,
    modelId: project?.modelId,
  });

  useEffect(() => {
    if (project?.hasOwnProperty("projectId")) {
      setFormData({
        name: project?.name,
        description: project?.description,
        modelId: project?.modelId,
      });
    }
  }, [project]);

  const changeName = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      name: e.target.value,
    }));
  };

  const changeDescription = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      description: e.target.value,
    }));
  };

  const closeUp = () => {
    editProject(null);
  };

  const saveUp = () => {
    editProject(null);
    saveEditProject({
      projectId: project?.projectId,
      name: formData.name,
      description: formData.description,
    });
  };

  return (
    <Modal
      isOpen={project?.hasOwnProperty("projectId")}
      onRequestClose={closeUp}
      style={customStyles}
    >
      <p style={{ paddingBottom: "1px", fontWeight: "bold" }}>Project name:</p>
      <input
        style={{ width: "600px" }}
        onChange={changeName}
        value={formData.name}
      />

      <div style={{ paddingBottom: "2px" }}>
        <p style={{ paddingBottom: "2px", fontWeight: "bold" }}>
          Project Description:
        </p>
        <textarea
          className="newPMInputs"
          onChange={changeDescription}
          value={formData.description}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <p style={{ paddingRight: "15px", fontWeight: "bold" }}>Pathway Template:</p>
        <p>{modelNames[formData.modelId - 1]}</p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: 20,
          marginTop: "10px",
        }}
      >
        <button
          style={{
            backgroundColor: "grey",
            width: "100px",
            height: "30px",
            color: style.colors.white,
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={closeUp}
        >
          Cancel
        </button>
        <button
          style={{
            backgroundColor: style.colors.primaryBlue,
            width: "100px",
            height: "30px",
            color: style.colors.white,
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={saveUp}
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  project: state.projects.editProject,
  style: state.local.style,
});

export default connect(mapStateToProps, {
  createProject,
  editProject,
  saveEditProject,
})(NewProjectModal) as any;
